import { render, staticRenderFns } from "./CorrectAnswer.vue?vue&type=template&id=3b2a7f57&"
import script from "./CorrectAnswer.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports